import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useExtendedState from '../../hooks/useExtendedState';
import { date } from '../../utils';
import useSingleValidator from '../../hooks/useSingleValidator';
import { auctionDateValidator } from '../../validators/auctions';
import DateTimeField from '../fields/DateTimeField';

ClosureTimeProvider.propTypes = {
    setVariables: PropTypes.func.isRequired,
    setValid: PropTypes.func.isRequired,
};

function ClosureTimeProvider(props) {
    const {
        setVariables,
        setValid,
    } = props;
    const { t } = useTranslation();
    const closingTimeState = useExtendedState(date());
    const { validator } = useSingleValidator(false, useMemo(() => auctionDateValidator(t), [t]));
    const handleNewClosingTime = (newClosingTime) => {
        setVariables({
            closureTime: newClosingTime instanceof Date ? newClosingTime.toISOString() : null,
        });
    };
    const handleValidity = (newValue, isValid) => {
        setValid(isValid);
    };
    return (
        <div className="closure-time-provider">
            <DateTimeField
                label={t('auctions.auction-setup.closing')}
                state={closingTimeState}
                onChange={handleNewClosingTime}
                onValidated={handleValidity}
                className="closure-time-provider--fields--closing-time wide"
                inputId="closure-time-provider--fields--closing-time"
                invalidBefore={date()}
                validator={validator}
                validateOnLoad
                isRequired
            />
        </div>
    );
}

export default ClosureTimeProvider;
